<template>
    <div class="flex flex-col mx-auto w-full p-12 lg:p-24 text-left -mt-32 md:-mt-12" style="max-width: 1400px;"
        id="grid">
        <h2 class="font-written text-4xl">Themenwelt</h2>
        <div class="flex items-center gap-3 mt-1">
            <img src="@/assets/icons/click.png" class="h-5 opacity-50" alt="Klicke um mehr zu erfahren">
            <p class="text-sm text-gray-500 mt-2"><span class="font-bold">Klicken,</span> um mehr zu erfahren.
            </p>
        </div>
        <div class="flex lg:flex-row flex-col gap-2 w-full mt-5">
            <button class="text-left shadow-md rounded-2xl overflow-hidden w-full lg:w-1/3 h-64 lg:h-[400px] group relative cursor-pointer select-none duration-200
                ring-primary-default/80 hover:ring-4 ring-offset-2"
                @click="$router.push('/themenwelt/gottesdienst')">
                <div
                    class="flex flex-col p-5 relative z-10 text-white h-full bg-gradient-to-t from-black/50 to-black/0">
                    <h3 class="text-bold font-bold md:text-2xl text-lg mt-auto">Gottesdienst</h3>
                    <div v-if="data?.length > 0">
                        <p class="mt-3">{{ moment(data[0]?.date, "DD.MM.YYYY").format("dddd") }}, {{ data[0]?.time }} in
                            {{ data[0]?.location.split(',').reverse()[0].replace(/\d+/g, "") }}</p>
                        <p class="text-white/70 text-sm">Nächster Termin</p>
                    </div>
                </div>
                <img src="@/assets/grid/gottesdienst.webp" alt="Gottesdienste öffnen"
                    class="absolute h-full w-full object-cover object-left-bottom top-0 left-0 group-hover:scale-105 duration-1000">
            </button>
            <div class="flex-auto h-full flex flex-col relative gap-2 h-auto lg:h-[400px]">
                <div class="w-full flex h-1/2 gap-2">
                    <button
                        class="text-left w-1/2 lg:h-auto h-48 shadow-md rounded-2xl relative flex overflow-hidden group 
                        cursor-pointer select-none duration-200 ring-primary-default/80 hover:ring-4 ring-offset-2"
                        @click="$router.push('/themenwelt/pfadfinder')">
                        <div
                            class="flex flex-col p-5 relative z-10 text-white h-full w-full bg-gradient-to-tr from-black/50 to-black/0">
                            <h3 class="text-bold font-bold md:text-2xl text-lg mt-auto">Pfadfinder</h3>
                        </div>
                        <img src="@/assets/grid/pfadfinder.webp" alt="Pfadfinder öffnen"
                            class="absolute h-full w-full object-cover top-0 left-0 object-center group-hover:scale-105 duration-1000">
                    </button>
                    <button
                        class="text-left w-1/2 lg:h-auto h-48 shadow-md rounded-2xl relative flex overflow-hidden group 
                        cursor-pointer select-none duration-200 ring-primary-default/80 hover:ring-4 ring-offset-2"
                        @click="$router.push('/themenwelt/jugendliche')">
                        <div
                            class="flex flex-col p-5 relative z-10 text-white h-full w-full bg-gradient-to-tr from-black/50 to-black/0">
                            <h3 class="text-bold font-bold md:text-2xl text-lg mt-auto">Jugendliche</h3>
                        </div>
                        <img src="@/assets/grid/jugendliche.webp" alt="Jugendgruppe öffnen"
                            class="absolute h-full w-full object-cover top-0 left-0 object-center group-hover:scale-105 duration-1000">
                    </button>
                </div>
                <div class="w-full flex h-1/2 gap-2">
                    <button
                        class="text-left w-1/2 lg:h-auto h-48 shadow-md rounded-2xl relative flex overflow-hidden group 
                        cursor-pointer select-none duration-200 ring-primary-default/80 hover:ring-4 ring-offset-2"
                        @click="$router.push('/themenwelt/gemeindenachmittag')">
                        <div
                            class="flex flex-col p-5 relative z-10 text-white h-full w-full bg-gradient-to-tr from-black/50 to-black/0">
                            <h3 class="text-bold font-bold md:text-2xl text-lg mt-auto hidden sm:flex">Gemeindenachmittag
                            </h3>
                            <h3 class="text-bold font-bold md:text-2xl text-lg mt-auto sm:hidden flex">Gemeinde-nachmittag
                            </h3>
                        </div>
                        <img src="@/assets/grid/kaffee.webp" alt="Gemeindenachmittag öffnen"
                            class="absolute h-full w-full object-cover top-0 left-0 object-center group-hover:scale-105 duration-1000">
                    </button>
                    <button
                        class="text-left w-1/2 lg:h-auto h-48 shadow-md rounded-2xl relative flex overflow-hidden group 
                        cursor-pointer select-none duration-200 ring-primary-default/80 hover:ring-4 ring-offset-2"
                        @click="$router.push('/themenwelt/frauenkreis')">
                        <div
                            class="flex flex-col p-5 relative z-10 text-white h-full w-full bg-gradient-to-tr from-black/50 to-black/0">
                            <h3 class="text-bold font-bold md:text-2xl text-lg mt-auto">Frauenkreis</h3>
                        </div>
                        <img src="@/assets/grid/menschen.webp" alt="Frauenkreis öffnen"
                            class="absolute h-full w-full object-cover top-0 left-0 object-center group-hover:scale-105 duration-1000">
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import "moment/locale/de";

export default {
    name: "Grid",
    data() {
        return {
            moment,
            data: []
        }
    },
    async created() {
        this.data = await this.$userStore.getData();
    }
}
</script>

<style></style>